import { BodyText, Heading, LinkText } from '@postscript/components';
import ComponentLinks from '../Layout/ComponentLinks';
import DisplayCard from '../Layout/DisplayCard';
import {
  StyledBlockHeading,
  StyledComponentCardStack,
} from '../Layout/SimpleStyledComponents';
import SystemBlock from '../Layout/SystemBlock';

const ComponentsSection = (): JSX.Element => {
  return (
    <SystemBlock id="components" data-theme="dark">
      <StyledBlockHeading>
        <Heading as="h2" size="small">
          Components
        </Heading>
        <BodyText size="large">
          Documented patterns and components enable fast and meaningful change
          by promoting efficiency, consistency, and scalability.
        </BodyText>
      </StyledBlockHeading>

      <StyledComponentCardStack>
        <DisplayCard
          heading="Core • Components"
          emoji="puzzle-piece"
          description="This is our primary library of components, available in Figma and
              code and fully documented in Storybook."
          actions={
            <ComponentLinks
              figmaLink="https://www.figma.com/file/g4xKIzMoQYpdi4BbF3WsKp/Core-%E2%80%A2-Components"
              storybookLink="https://components.postscript.io"
            />
          }
          colspan={2}
        />

        <DisplayCard
          heading="Core • Styles"
          emoji="top-hat"
          description="These are the base Figma styles shared between Studio and Product. They include colors, type, layout grid, and effect styles."
          actions={
            <ComponentLinks figmaLink="https://www.figma.com/file/IbDCIkWB3piIgwRHkQouti/Core-%E2%80%A2-Styles" />
          }
          colspan={2}
        />

        <DisplayCard
          heading="Product • Components"
          emoji="hammer-and-wrench"
          description="Product Design's custom component library built off of Core · Styles and Core · Components and relating to the Postscript App."
          actions={
            <ComponentLinks
              figmaLink="https://www.figma.com/file/0Hw1FUl1dkn89qmVqpjsoD/Product-%E2%80%A2-Components"
              storybookLink="https://components.postscript.io/?path=/docs/product-components--using-product-components"
            />
          }
          colspan={2}
        />

        <DisplayCard
          heading="Core • Icons"
          emoji="radioactive"
          description={
            <>
              Our shared icon set, based on the{' '}
              <LinkText
                href="https://iconic.app"
                target="_blank"
                rel="noreferrer"
              >
                Iconic
              </LinkText>{' '}
              library.
            </>
          }
          actions={
            <ComponentLinks
              figmaLink="https://www.figma.com/file/RyTMBYVblMEJGXWNyuzNrV/Core-%E2%80%A2-Icons?node-id=2%3A20"
              storybookLink="https://components.postscript.io/?path=/docs/basic-components-icon--default"
            />
          }
          colspan={2}
        />
      </StyledComponentCardStack>
    </SystemBlock>
  );
};

export default ComponentsSection;
